import React, { Component } from 'react';
import Layout from '../ui/Layout';
import { Link } from 'react-router-dom';

class NotFound extends Component {
  componentDidMount() {
    document.body.classList.add('error404', 'hfeed', 'no-sidebar');
  }
  componentWillUnmount() {
    document.body.classList.remove('error404', 'hfeed', 'no-sidebar');
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);

    return (
      <Layout>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main">
              <div className="container">
                <section className="error-404 not-found">
                  <h1 className="page-title smaller text-center">
                    Sorry the page you requested does not exists.
                  </h1>
                  <br />
                  <div className="row justify-content-center">
                    <div className="col-md-6 intro-p">
                      <p>
                        Please use one of the links below to help navigate to what you’re looking for.
                      </p>
                      <p><a href="/">Home</a></p>
                      <p><Link to="/shop">Shop</Link></p>
                      <p><a href="/wines/">Our Wines</a></p>
                      <p><a href="/vineyards/">Our Vineyards</a></p>
                      <p><a href="/visit/">Visit Us</a></p>
                      <p><a href="/wine-club/">Club Twomey</a></p>
                      <p><a href="/about/">Contact</a></p>
                    </div>
                  </div>
                </section>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

export default NotFound;
